const map = {
  objects: {},
  pendingObjectData: {},
};

window.map = map;

function MapObject(id, type, parent) {
  this.id = id;
  this.type = type;
  this.parent = parent;
  this.children = [];

  Object.defineProperties(this, {
    // helpers
    label: {
      get: function () {
        return this.id.split("/").pop();
      },
    },
  });
}

const borg = new MapObject("*", "borg", null);
map.objects[borg.id] = borg;

export { borg, MapObject };
export default map;
